// removed by extract-text-webpack-plugin
module.exports = {"readonly":"_33AegyGk8n_eDYK5OULiZK","noBorder":"_3Vhe1XvyD3mFL0dbxeqLjB","no-border":"_3Vhe1XvyD3mFL0dbxeqLjB","no-right-border-radius":"xDZmUsL_ogCMQSPH4NLL0","noRightBorderRadius":"xDZmUsL_ogCMQSPH4NLL0"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/Dropdown/Dropdown.scss
// module id = ./node_modules/wix-style-react/dist/es/src/Dropdown/Dropdown.scss
// module chunks = 0